/* Win Motoring theme — carousels, gallery, drawers, collection toolbar */
(function () {
  'use strict';

  /* ---------- Carousel prev/next buttons ---------- */
  document.querySelectorAll('[data-carousel-controls]').forEach(function (controls) {
    var section = controls.closest('.section') || controls.closest('section');
    var track = section ? section.querySelector('[data-carousel]') : null;
    if (!track) return;

    var prev = controls.querySelector('[data-prev]');
    var next = controls.querySelector('[data-next]');

    function step() {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    function update() {
      /* Hide the arrows entirely when everything already fits. */
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      controls.style.display = scrollable ? '' : 'none';
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    var motionOK = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: motionOK ? 'smooth' : 'auto' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: motionOK ? 'smooth' : 'auto' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Product gallery thumbnails ---------- */
  var mainImg = document.getElementById('GalleryMainImg');
  if (mainImg) {
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    thumbs.forEach(function (thumb, i) {
      if (i === 0) thumb.classList.add('is-active');
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.dataset.full;
        mainImg.removeAttribute('srcset');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Per-wheel quantity hint (wheels priced each) ---------- */
  var qtyTotal = document.getElementById('QtyTotal');
  var qtyInput = document.getElementById('Quantity');
  if (qtyTotal && qtyInput) {
    var unitPrice = parseInt(qtyTotal.dataset.unitPrice, 10);
    var money = function (cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    qtyInput.addEventListener('input', function () {
      var n = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyTotal.textContent = n === 4
        ? 'Set of 4 — ' + money(unitPrice * 4)
        : n + (n === 1 ? ' wheel — ' : ' wheels — ') + money(unitPrice * n) + (n === 1 ? '. Most cars need 4.' : '');
    });
  }

  /* ---------- Product page: clamp quantity to stock ---------- */
  if (qtyInput && qtyInput.max) {
    qtyInput.addEventListener('change', function () {
      var max = parseInt(qtyInput.max, 10);
      var n = parseInt(qtyInput.value, 10) || 1;
      if (n > max) qtyInput.value = max;
      if (n < 1) qtyInput.value = 1;
    });
  }

  /* ---------- Product recommendations (Section Rendering API) ---------- */
  var recs = document.querySelector('[data-recommendations]');
  if (recs && recs.dataset.url) {
    fetch(recs.dataset.url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('.product-recommendations');
      if (inner) recs.appendChild(inner);
    }).catch(function () {});
  }

  /* ---------- Cart: auto-submit quantity changes ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) { input.disabled = false; form.classList.add('is-updating'); form.submit(); }
    });
  });

  /* ---------- Cart: remove via AJAX (the GET /cart/change URL 400s) ---------- */
  document.querySelectorAll('.cart-table__remove').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var href = link.getAttribute('href');
      var m = href.match(/[?&]id=([^&]+)/);
      var key = m ? decodeURIComponent(m[1]) : null;
      if (!key) { location.href = href; return; }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) {
        if (r.ok) location.reload(); else location.href = href;
      }).catch(function () { location.href = href; });
    });
  });

  /* ---------- Collection toolbar ---------- */
  var toolbar = document.querySelector('[data-collection-toolbar]');
  if (toolbar) {
    var baseUrl = toolbar.dataset.collectionUrl;
    var fitmentTag = toolbar.dataset.fitmentTag || '';
    var view = toolbar.dataset.view || '';

    function navigate(brand, sort) {
      var tags = [fitmentTag, brand].filter(Boolean);
      var url = baseUrl + (tags.length ? '/' + tags.join('+') : '');
      var params = new URLSearchParams();
      if (sort) params.set('sort_by', sort);
      if (view) params.set('view', view);
      var qs = params.toString();
      location.href = url + (qs ? '?' + qs : '');
    }

    var sortSel = toolbar.querySelector('[data-sort-select]');
    var brandSel = toolbar.querySelector('[data-brand-select]');
    var currentBrand = brandSel ? brandSel.value : '';
    var currentSort = new URLSearchParams(location.search).get('sort_by') || '';

    if (sortSel) sortSel.addEventListener('change', function () {
      navigate(currentBrand, sortSel.value);
    });
    if (brandSel) brandSel.addEventListener('change', function () {
      navigate(brandSel.value, currentSort);
    });

    /* Client-side filtering: price dropdown + sidebar checkbox groups.
       Sidebar groups are built from product-card data attributes, so the
       sidebar reflects exactly what is on the page (the page size is set
       high enough that every category fits on one page). */
    var priceSel = toolbar.querySelector('[data-price-select]');
    var grid = document.querySelector('[data-product-grid]');
    var sidebar = document.querySelector('[data-filter-sidebar]');
    var clearLink = toolbar.querySelector('[data-filter-clear]');
    var toggleBtn = toolbar.querySelector('[data-filter-toggle]');
    var pagination = document.querySelector('.pagination');
    var isMobile = function () { return window.matchMedia('(max-width: 989px)').matches; };

    if (grid) {
      var countLabel = toolbar.querySelector('[data-count-label]');
      var emptyNote = document.querySelector('[data-filter-empty]');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
      var total = cards.length;
      var collectionTotal = countLabel ? parseInt(countLabel.dataset.totalCount, 10) || total : total;

      var vehicleNames = {};
      var namesEl = sidebar ? sidebar.querySelector('[data-vehicle-names]') : null;
      if (namesEl) { try { vehicleNames = JSON.parse(namesEl.textContent); } catch (e) {} }

      function vals(card, key, multi) {
        var v = card.dataset[key] || '';
        if (!v) return [];
        return multi ? v.split('|').filter(Boolean) : [v];
      }

      var GROUPS = [
        { key: 'available', label: 'Availability', multi: false, fmt: function (v) { return v === 'true' ? 'In stock' : 'Sold out'; } },
        { key: 'vendor', label: 'Brand', multi: false },
        { key: 'bolt', label: 'Bolt Pattern', multi: true, fmt: function (v) { return v.charAt(0).toUpperCase() + v.slice(1); } },
        { key: 'diameter', label: 'Diameter', multi: false, fmt: function (v) { return v + '"'; } },
        { key: 'color', label: 'Color', multi: false },
        { key: 'vehicles', label: 'Vehicle', multi: true, fmt: function (v) { return vehicleNames[v] || v; } }
      ];

      var active = {};
      var checkboxes = [];

      function anyActive() {
        if (priceSel && priceSel.value) return true;
        return GROUPS.some(function (g) { return active[g.key] && active[g.key].size; });
      }

      function matches(card) {
        var ok = true;
        GROUPS.forEach(function (g) {
          var set = active[g.key];
          if (!set || !set.size) return;
          var cv = vals(card, g.key, g.multi);
          if (!cv.some(function (v) { return set.has(v); })) ok = false;
        });
        var range = priceSel ? priceSel.value : '';
        if (ok && range) {
          var parts = range.split('-');
          var min = (parseFloat(parts[0]) || 0) * 100;
          var max = parts[1] ? parseFloat(parts[1]) * 100 : Infinity;
          var p = parseInt(card.dataset.price, 10);
          if (!(p >= min && p < max)) ok = false;
        }
        return ok;
      }

      function apply() {
        var shown = 0;
        cards.forEach(function (card) {
          var ok = matches(card);
          card.hidden = !ok;
          if (ok) shown++;
        });
        var filtering = anyActive();
        if (countLabel) {
          countLabel.textContent = filtering
            ? shown + ' of ' + total + (total === 1 ? ' product' : ' products')
            : collectionTotal + (collectionTotal === 1 ? ' product' : ' products');
        }
        if (emptyNote) emptyNote.hidden = shown > 0;
        if (clearLink) clearLink.hidden = !filtering;
        if (pagination) pagination.hidden = filtering && shown === 0;
        var params = new URLSearchParams(location.search);
        var range = priceSel ? priceSel.value : '';
        if (range) params.set('price', range); else params.delete('price');
        var qs = params.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
      }

      if (clearLink) clearLink.addEventListener('click', function (e) {
        e.preventDefault();
        GROUPS.forEach(function (g) { if (active[g.key]) active[g.key].clear(); });
        checkboxes.forEach(function (cb) { cb.checked = false; });
        if (priceSel) priceSel.value = '';
        apply();
      });

      if (sidebar) {
        var groupsWrap = sidebar.querySelector('[data-filter-groups]');
        var built = 0;
        GROUPS.forEach(function (g) {
          var counts = {};
          cards.forEach(function (card) {
            vals(card, g.key, g.multi).forEach(function (v) {
              counts[v] = (counts[v] || 0) + 1;
            });
          });
          var keys = Object.keys(counts);
          if (keys.length < 2) return;
          if (g.key === 'vehicles') {
            var order = Object.keys(vehicleNames);
            keys.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
          } else if (g.key === 'diameter') {
            keys.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
          } else if (g.key === 'available') {
            keys.sort().reverse();
          } else {
            keys.sort();
          }
          active[g.key] = new Set();
          var det = document.createElement('details');
          det.className = 'filter-group';
          det.open = !isMobile();
          var sum = document.createElement('summary');
          sum.textContent = g.label;
          det.appendChild(sum);
          var ul = document.createElement('ul');
          keys.forEach(function (v) {
            var li = document.createElement('li');
            var label = document.createElement('label');
            var cb = document.createElement('input');
            cb.type = 'checkbox';
            cb.value = v;
            cb.addEventListener('change', function () {
              if (cb.checked) active[g.key].add(v); else active[g.key].delete(v);
              apply();
            });
            checkboxes.push(cb);
            var span = document.createElement('span');
            span.textContent = g.fmt ? g.fmt(v) : v;
            var count = document.createElement('span');
            count.className = 'count';
            count.textContent = '(' + counts[v] + ')';
            label.appendChild(cb);
            label.appendChild(span);
            label.appendChild(count);
            li.appendChild(label);
            ul.appendChild(li);
          });
          det.appendChild(ul);
          groupsWrap.appendChild(det);
          built++;
        });
        if (built > 0) {
          sidebar.hidden = false;
          var layout = sidebar.closest('.collection-layout');
          if (layout) layout.classList.add('has-sidebar');
        }
        if (isMobile()) {
          sidebar.querySelectorAll('details.filter-group--links').forEach(function (d) { d.open = true; });
        }
      }

      if (priceSel) {
        priceSel.addEventListener('change', apply);
        var initial = new URLSearchParams(location.search).get('price');
        if (initial) { priceSel.value = initial; apply(); }
      }
    }

    if (toggleBtn && sidebar) {
      toggleBtn.addEventListener('click', function () {
        var open = sidebar.classList.toggle('is-open');
        toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggleBtn.classList.toggle('is-active', open);
        if (open) sidebar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* ---------- Vehicle / bolt jump selects ---------- */
  document.querySelectorAll('[data-tag-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var base = sel.dataset.baseUrl;
      location.href = sel.value ? base + '/' + sel.value : base;
    });
  });

  /* ---------- Drawers: pin mobile menu below header, close on Esc/outside ---------- */
  var drawerToggle = document.getElementById('MenuDrawer');
  if (drawerToggle) drawerToggle.addEventListener('toggle', function () {
    var header = document.querySelector('.site-header');
    var drawer = drawerToggle.querySelector('.menu-drawer');
    if (header && drawer) drawer.style.top = header.getBoundingClientRect().bottom + 'px';
  });

  function closeDrawers(except) {
    ['MenuDrawer', 'SearchDrawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el !== except) el.removeAttribute('open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });
  document.addEventListener('click', function (e) {
    var inDrawer = e.target.closest('#MenuDrawer, #SearchDrawer');
    if (!inDrawer) closeDrawers();
    else closeDrawers(inDrawer);
  });
})();
